import type { NewRatingInputInput } from '@packages/gql/generated/shopping/graphql';
import type { CreateReviewFormSchema } from '../../AddReviewFormValidation/AddReviewFormValidation';

/**
 * @param {Object} param0 - values from form
 * @param locale - actual selected locale
 * @returns {NewRatingInputInput} - returns object for the create rating endpoint
 */
export const createSubmitData = (
  { productId, description, rating, name, title, recommended }: CreateReviewFormSchema,
  locale: string,
): NewRatingInputInput => ({
  locale,
  productId,
  title,
  description,
  rating,
  reviewer: {
    nickname: name,
  },
  // recommended is initialized as "null" in the form, so we can safely pass it to the endpoint
  recommended,
});
